import { html, KompisElement } from '@inter-ikea-kompis/web-component';
import ActionListItem from '../action-list-item/ActionListItem.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 *
 * Component that renders a list of {ActionListItem}.
 */
export default class ActionList extends KompisElement {
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				:host {
					display: block;
				}
			</style>
			<div @keydown="${(event) => this.onKeyDown(event)}">
				<slot></slot>
			</div>
		`;
    }
    /**
     * When key down.
     *
     * @param event Keyboard event.
     */
    onKeyDown(event) {
        switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                event.preventDefault();
                this.changeButtonFocus(+1);
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                event.preventDefault();
                this.changeButtonFocus(-1);
                break;
        }
    }
    /**
     * Normally there would be just one kind of control of ActionListItems within the ActionList, for example only radio buttons, or only checkboxes, but it's possible to have a mix.
     * There can theoretically be several groups of radio buttons which is what this logic deals with.
     * Navigation using the arrow keys should only navigate within one group of radio buttons.
     */
    getRadioButtonGroups() {
        const radioButtons = Array.from(this.children)
            .filter((child) => child instanceof ActionListItem)
            .map((actionItem) => {
            return actionItem.shadowRoot?.querySelector(actionItem.customElements?.getInternalName('kompis-radio-button'));
        });
        return radioButtons
            .reduce((groups, radioButton) => {
            if (radioButton && !radioButton.disabled) {
                groups[groups.length - 1].push(radioButton);
            }
            else if (!radioButton) {
                // Not a radio button control? Create a new group.
                groups.push([]);
            }
            return groups;
        }, [[]])
            .filter((group) => group.length);
    }
    /**
     * @returns The focused kompis radio button within this shadow dom or null if there isn't one in focus.
     */
    findFocusedRadioButton() {
        const rootNode = this.getRootNode();
        if (this.isShadowRoot(rootNode)) {
            const internalTagName = (rootNode.activeElement)?.customElements?.getInternalName('kompis-radio-button');
            return internalTagName
                ? rootNode.activeElement?.shadowRoot?.querySelector(internalTagName) || null
                : null;
        }
        return null;
    }
    changeButtonFocus(increment) {
        const groups = this.getRadioButtonGroups();
        const focusedRadioButton = this.findFocusedRadioButton();
        const group = groups.find((group) => group.some((element) => element === focusedRadioButton));
        if (group) {
            const focusedElement = group.find((element) => element === focusedRadioButton);
            if (focusedElement) {
                const index = group.indexOf(focusedElement);
                group[(group.length + index + increment) % group.length]?.focus();
            }
        }
    }
    isShadowRoot(target) {
        return 'activeElement' in target;
    }
}
//# sourceMappingURL=ActionList.js.map